import D1 from '../../components/ExcerciseTypes/Design/TypeIn';
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";



const json = {
  1: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P21-E1',
    audio: '',
    video: '',
    component: T6,
    exerciseKey: 'img/FriendsPlus/Page21/E1/Key/answerKey.png',
    inputSize: 300,
    checkUppercase: true,
    titleImage: 'img/FriendsPlus/Page21/E1/title.jpg',
    // titleQuestion: [{ num: '1', title: 'Write answers that are true for you. Write <i>Yes, I did</i> or <i>No, I didn’t</i>', color: "#5B5A5D" }],
    questionImage: [],
    questions: [
      {
        title:
          `
          <div style='line-height: 58px;'>
            <div><b>1</b> Does the boy have a drink ? <u style='color: gray;'><i> Yes, he does. </i></u></div>
            <div><b>2</b> Does the girl have a drink? # </div>
            <div><b>3</b> Does he have a pizza? # </div>
            <div><b>4</b> Does she have noodles ? # </div>
          </div>
          `,
        answer: [
          "Yes, she does.",
          "No, he doesn't.",
          "No, she doesn't.",
        ],
      },
    ]
  },
  2: { // Exercise num
    unit: 'Unit 3',
    id: 'WB4-V2-U3-P21-E2',
    audio: '',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page21/E2/Key/answerKey.png',
    checkUppercase: true,
    padding: '0 16px',
    question: [
    ],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page21/E2/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page21/E2/2.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/3.jpg', input: true, answer: "c" },
        { url: 'img/FriendsPlus/Page21/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page21/E2/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page21/E2/6.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/7.jpg', input: true, answer: "They like the sandwiches." },
        { url: 'img/FriendsPlus/Page21/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page21/E2/9.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page21/E2/10.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/11.jpg', input: true, answer: "b" },
        { url: 'img/FriendsPlus/Page21/E2/12.jpg' },
      ],
      [
        // Column7
        { url: 'img/FriendsPlus/Page21/E2/13.jpg' },
      ],
      [
        // Column8
        { url: 'img/FriendsPlus/Page21/E2/14.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/15.jpg', input: true, answer: "He doesn't have his chicken." },
        { url: 'img/FriendsPlus/Page21/E2/16.jpg' },
      ],
      [
        // Column9
        { url: 'img/FriendsPlus/Page21/E2/17.jpg' },
      ],
      [
        // Column10
        { url: 'img/FriendsPlus/Page21/E2/18.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/19.jpg', input: true, answer: "a" },
        { url: 'img/FriendsPlus/Page21/E2/20.jpg' },
      ],
      [
        // Column11
        { url: 'img/FriendsPlus/Page21/E2/21.jpg' },
      ],
      [
        // Column12
        { url: 'img/FriendsPlus/Page21/E2/22.jpg' },
        { url: 'img/FriendsPlus/Page21/E2/23.jpg', input: true, answer: "I'm not hungry." },
        { url: 'img/FriendsPlus/Page21/E2/24.jpg' },
      ],


    ]
  },


}

export default json;